import angular from 'angular';

import template from '../settings/settings.html';
import userSettings from '../settings/users/UserSettings.directive';
import settingsApiPage from './api/SettingsApiPage.directive';
import appealsSettings from './appeals/AppealsSettings.directive';
import appealSourcesSettings from './appealSources/AppealSourcesSettings.directive';
import customFieldsPage from './customFields/CustomFieldsPage.directive';
import documentTemplatesSettings from './documentTemplates/DocumentTemplatesSettings.directive';
import settingsEmbedPage from './embed/SettingsEmbedPage.directive';
import easyBusySettings from './integrations/easyBusy/EasyBusySettings.directive';
import integrationList from './integrations/IntegrationList.directive';
import ringostatSettings from './integrations/ringostat/RingostatSettings.directive';
import telegramSettings from './integrations/telegram/TelegramSettings.directive';
import wepsterSettings from './integrations/wepster/WepsterSettings.directive';
import loanSettings from './loans/LoanSettings.directive';
import loanSettingsList from './loans/LoanSettingsList.directive';
import opportunityLabelsSettings from './opportunityLabels/OpportunityLabelsSettings.directive';

(function () {
  'use strict';

  angular.module('settings').config(config);

  config.$inject = ['$stateProvider'];

  /** @param {any} $stateProvider */
  function config($stateProvider) {
    $stateProvider
      .state('settings', {
        url: '/settings',
        template,
        controller() {
          this.isTestEnv =
            /^(localhost|0\.0\.0\.0|test\d?\w*\.|[^.]+\.test\d?\w*\.)/.test(
              window.location.hostname,
            );
        },
        controllerAs: 'vm',
      })
      .state('settings.customization', {
        url: '/customization',
        template: require('../settings.customization/customization.html'),
        controller: 'settingsCustomizationCtrl',
        controllerAs: 'vm',
      })
      .state('settings.users', {
        url: '/users',
        template: () => `<div ${userSettings.htmlName}></div>`,
      })
      .state('settings.customfields', {
        url: '/custom-fields',
        template: () => `<div ${customFieldsPage.htmlName}></div>`,
      })
      .state('settings.stackingplan', {
        url: '/stacking-plan',
        template: require('../settings.stacking.plan/settings.stacking.plan.html'),
        controller: 'settingsStackingPlanCtrl',
        controllerAs: 'vm',
      })
      .state('settings.embed', {
        url: '/embed',
        template: () => `<div ${settingsEmbedPage.htmlName}></div>`,
      })
      .state('settings.appeals', {
        url: '/appeals',
        template: () => `<div ${appealsSettings.htmlName}></div>`,
      })
      .state('settings.appealsources', {
        url: '/appeal-sources',
        template: () => `<div ${appealSourcesSettings.htmlName}></div>`,
      })
      .state('settings.documenttemplates', {
        url: '/document-templates',
        template: () => `<div ${documentTemplatesSettings.htmlName}></div>`,
      })
      .state('settings.opportunitylabels', {
        url: '/stages-and-statuses',
        template: () => `<div ${opportunityLabelsSettings.htmlName}></div>`,
      })
      .state('settings.loans', {
        url: '/loans',
        template: () =>
          `<ui-view><div ${loanSettingsList.htmlName}></div></ui-view>`,
      })
      .state('settings.loans.view', {
        url: '/:id',
        template: () => `<div ${loanSettings.htmlName}></div>`,
      })
      .state('settings.api', {
        url: '/api',
        template: () => `<div ${settingsApiPage.htmlName}></div>`,
      })
      .state('settings.integrations', {
        url: '/integrations',
        template: () => `<div ${integrationList.htmlName}></div>`,
      })
      .state('settings.wepster', {
        url: '/integrations/wepster',
        template: () => `<div ${wepsterSettings.htmlName}></div>`,
      })
      .state('settings.easyBusy', {
        url: '/integrations/easy-busy',
        template: () => `<div ${easyBusySettings.htmlName}></div>`,
      })
      .state('settings.ringostat', {
        url: '/integrations/ringostat',
        template: () => `<div ${ringostatSettings.htmlName}></div>`,
      })
      .state('settings.telegram', {
        url: '/integrations/telegram',
        template: () => `<div ${telegramSettings.htmlName}></div>`,
      });
  }
})();
